<div class="thp-form-container">
    <form [formGroup]="salaryForm" class="thp-form">
      <label class="thp-header">{{"talent-happy-path.talent-profile.salary.title" | translate}}</label>

      <div class="field-group">
        <label id="hourly-pay-group-label" class="field-label"> {{"talent-happy-path.talent-profile.salary.hourly-pay" | translate}} </label>
        <mat-form-field aria-labelledby="hourly-pay-group-label" style="width: 100%" id="desired-hourly-rate-input">
          <mat-label> {{"talent-happy-path.talent-profile.salary.desired-hourly" | translate}} </mat-label>
          <span matPrefix>{{currencySymbol}}&nbsp;</span>
          <input matInput type="text" placeholder="Desired Hourly Rate" formControlName="desiredHourlyRate" [value]="talentSalary?.desiredHourlyRate | number:'1.0'">
        </mat-form-field>
        <mat-form-field aria-labelledby="hourly-pay-group-label" style="width: 100%" id="minimum-hourly-rate-input">
          <mat-label> {{"talent-happy-path.talent-profile.salary.minimum-hourly" | translate}} </mat-label>
          <span matPrefix>{{currencySymbol}}&nbsp;</span>
          <input matInput type="text" formControlName="minimumHourlyRate" placeholder="Minimum Hourly Rate" [value]="talentSalary?.minimumHourlyRate | number:'1.0'">
          <span matSuffix *ngIf="hasHourlyError"><svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path fill-rule="evenodd" clip-rule="evenodd"
                      d="M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM11 17V15H13V17H11ZM11 7V13H13V7H11Z"
                      fill="#E70608" />
                </svg>
          </span>
          <mat-error *ngIf="hasHourlyError" class="error">{{"talent-happy-path.talent-profile.salary.salary-error" | translate}}</mat-error>
        </mat-form-field>

        <label id="salary-pay-group-label" class="field-label"> {{"talent-happy-path.talent-profile.salary.salary-pay" | translate}} </label>
        <mat-form-field aria-labelledby="hourly-pay-group-label" style="width: 100%" id="desired-salary-rate-input">
          <mat-label> {{"talent-happy-path.talent-profile.salary.desired-salary" | translate}} </mat-label>
          <span matPrefix>{{currencySymbol}}&nbsp;</span>
          <input matInput type="text" formControlName="desiredYearlySalary" placeholder="Desired Salary" [value]="talentSalary?.desiredYearlySalary | number:'1.0'">
        </mat-form-field>
        <mat-form-field aria-labelledby="hourly-pay-group-label" style="width: 100%" id="minimum-salary-rate-input">
          <mat-label> {{"talent-happy-path.talent-profile.salary.minimum-salary" | translate}} </mat-label>
          <span matPrefix>{{currencySymbol}}&nbsp;</span>
          <input matInput type="text" formControlName="minimumYearlySalary" placeholder="Minimum Salary" [value]="talentSalary?.minimumYearlySalary | number:'1.0'">
          <span matSuffix *ngIf="hasSalaryError"><svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path fill-rule="evenodd" clip-rule="evenodd"
                d="M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM11 17V15H13V17H11ZM11 7V13H13V7H11Z"
                fill="#E70608" />
                </svg>
          </span>
          <mat-error *ngIf="hasSalaryError" class="error">{{"talent-happy-path.talent-profile.salary.hourly-error" | translate}}</mat-error>
        </mat-form-field>

      </div>
    </form>

  <div class="navigation-buttons">
    <button mat-stroked-button color="primary" class="back-btn" (click)="goToEmploymentPreferences()"><mat-icon>arrow_back</mat-icon>{{"talent-happy-path.buttons.back" | translate}}</button>
    <button [disabled]="!salaryForm.valid" color="primary" mat-flat-button class="next-btn" (click)="saveSalary()"><mat-icon>arrow_forward</mat-icon>{{"talent-happy-path.buttons.next" | translate}}</button>
  </div>

  <div class="button-container">
    <button mat-button class="later-button" (click)="isModalVisible = true" *ngIf="!fromNotAFit">{{"talent-happy-path.buttons.do-later" | translate}}</button>
    <app-confirmation-modal
      [isVisible]="isModalVisible"
      (isVisibleChange)="isModalVisible = $event"
      header="{{'talent-happy-path.talent-profile.later-modal.header' | translate}}"
      description="{{'talent-happy-path.talent-profile.later-modal.description' | translate}}"
      (cancel)="isModalVisible = false"
      (confirm)="doThisLater(); isModalVisible = false">
    </app-confirmation-modal>
  </div>
</div>
